import Axios from "axios";

import {
    getDataWithComp,
    getAlert,
    parseCurrency
} from "./SamuiUtils";

import {
    formatDateTime,
    formatThaiDateUiToDate,
    getCreateDateTime
} from "./DateUtils";

export async function manageWhItemData(
    itemId, // Item ไอดีของสิ่งนั้นๆ
    itemCode, // Item โค้ดของสิ่งนั้นๆ
    itemName, // ชื่อ Item นั้นๆ
    whId, // WarehouseID ของไอเทม
    docType, // ประเภท เช่น IN/OUT/AI/AO/TI/TO
    stcQty, // ค่าจำนวนที่กรอกจากหน้าจอ
    docId, // ไอดีเอกสาร
    docNo, // เลขเอกสาร
    docNoRef, // เลขเอกสารอ้างอิง
    stcRemark, // หมายเหตุ
    forceBalance = null // บังคับ STC_Balance (ใช้กับ CNT เพื่อ sync กับ itemBalance)
) {
    try {
        if (whId) {
            // Find WH_Item_Onhand By comp_id, item_id, wh_id
            let findItemOnHand = await getDataWithComp("WH_ITEM_Onhand", `AND Item_Id = ${itemId} AND WH_Id = ${whId}`);

            const prevOnhand =
                findItemOnHand.length > 0
                    ? parseCurrency(findItemOnHand[0].Item_Onhand)
                    : parseCurrency("0");
            const fromDelta = parseCurrency(await calculateNewQty(docType, prevOnhand, stcQty));
            // ใบนับสต็อก (CNT): บังคับยอดหลังนับ = forceBalance — ต้องเขียนทั้ง WH_ITEM_Onhand และ STC ให้ตรงกัน
            const forced =
                forceBalance != null && !Number.isNaN(parseCurrency(forceBalance));
            const newWhOnhand = forced ? parseCurrency(forceBalance) : fromDelta;

            // ถ้าเจอให้ Update WH_Item_Onhand แต่ถ้าไม่เจอให้ Insert WH_Item_Onhand
            if (findItemOnHand.length > 0) {
                // UPDATE WH_Item_Onhand
                const updateResponse = await Axios.post(`${process.env.REACT_APP_API_URL}/api/update-wh-item-on-hand`, {
                    last_qty: stcQty,
                    item_on_hand: newWhOnhand,
                    last_stc_seq: formatDateTime(new Date()),
                    last_stc_date: formatThaiDateUiToDate(getCreateDateTime()),
                    item_id: itemId,
                    wh_id: whId,
                    comp_id: window.localStorage.getItem('company')
                }, {
                    headers: { key: 'THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999' }
                });
                
                if (updateResponse.data.status !== "OK" && updateResponse.data.status !== "WARNING") {
                    throw new Error(updateResponse.data.message || "การอัปเดตจำนวนสินค้าไม่สำเร็จ");
                }
            } else {
                // INSERT WH_Item_Onhand
                const insertResponse = await Axios.post(`${process.env.REACT_APP_API_URL}/api/insert-wh-item-onhand`, {
                    item_id: itemId,
                    item_code: itemCode,
                    item_name: itemName,
                    item_barcode: null,
                    last_qty: stcQty,
                    item_on_hand: newWhOnhand,
                    wh_id: whId,
                    zone_id: parseCurrency("1"),
                    lt_id: parseCurrency("1"),
                    last_stc_seq: formatDateTime(new Date()),
                    last_stc_date: formatThaiDateUiToDate(getCreateDateTime()),
                    comp_id: window.localStorage.getItem('company'),
                    item_last_onhand: null
                }, {
                    headers: { key: 'THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999' }
                });
                
                if (insertResponse.data.status !== "OK") {
                    throw new Error(insertResponse.data.message || "การเพิ่มจำนวนสินค้าไม่สำเร็จ");
                }
            }

            // ทำการ Insert WH_ITEM_STC — STC_Balance ต้องตรงกับยอดใน WH_ITEM_Onhand หลังบันทึก
            const stcBalance = newWhOnhand;
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/insert-wh-item-stc`, {
                item_id: itemId,
                item_code: itemCode,
                item_name: itemName,
                doc_type: docType,
                ref_balance: parseCurrency("0"),
                stc_qty: stcQty,
                stc_balance: stcBalance,
                stc_date: formatThaiDateUiToDate(getCreateDateTime()),
                stc_by: window.localStorage.getItem('emp_id'),
                comp_id: window.localStorage.getItem('company'),
                doc_id: docId,
                doc_no: docNo,
                doc_noref: docNoRef,
                stc_remark: stcRemark,
                stc_seq: formatDateTime(new Date()),
                wh_id: whId,
                zone_id: parseCurrency("1"),
                lt_id: parseCurrency("1")
            }, {
                headers: { key: 'THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999' }
            });
        }
    } catch (error) {
        getAlert("FAILED", error)
        return null;
    }
}

// Method แยกสำหรับคำนวณค่าใหม่
export async function calculateNewQty(docType, currentQty, stcQty) {
    let newQty;

    switch (docType) {
        case 'BG':
        case 'IN':
        case 'AI':
        case 'TI':
        case 'CC':
            newQty = parseCurrency(currentQty) + parseCurrency(stcQty);
            break;
        case 'OUT':
        case 'AO':
        case 'TO':
            newQty = parseCurrency(currentQty) - parseCurrency(stcQty);
            break;
        case 'NC':
            newQty = parseCurrency(currentQty);
            break;
        default:
            throw new Error(`Unsupported docType: ${docType}`);
    }

    return newQty;
}
